/* eslint-disable react/require-default-props */
import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@telus/koodo-ui-kit'

// Use kit Typography only for token-driven cases; plain spans preserve
// legacy inline-className behavior across existing screens.
const BodySmall = ({
  id, children, className = '', textColor, tokens, variant, block, align
}) => {
  if (!tokens) {
    return (
      <span className={`text-xs ${textColor || 'text-copy'}  font-body ${className}`} id={id}>
        {children}
      </span>
    )
  }

  const Wrapper = block ? 'div' : 'span'
  return (
    <Wrapper className={className} id={id}>
      <Typography block={block} align={align} variant={variant} tokens={tokens}>
        {children}
      </Typography>
    </Wrapper>
  )
}

BodySmall.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  textColor: PropTypes.string,
  tokens: PropTypes.shape({}),
  variant: PropTypes.shape({}),
  block: PropTypes.bool,
  align: PropTypes.string
}

BodySmall.defaultProps = {
  variant: { size: 'small' },
  block: false,
  align: undefined
}

export default BodySmall
